import dayjs from "dayjs";
import type { DataMap } from "src/Modules/UserHistory/pages/OrdersList/components/OrderCard/constants";
import { formatNumber } from "src/utility";
import i18n from "src/i18n";

export const giftcardDataMap: DataMap = {
  referenceNumber: {
    get label() {
      return i18n.t("UserHistory.ordersList.referenceNumber");
    },
    value: (val) => val,
  },
  points: {
    get label() {
      return i18n.t("UserHistory.orderDetails.points");
    },
    value: (val) => i18n.t("UserHistory.orderDetails.pointsValue", { value: formatNumber(val) }),
  },
  value: {
    get label() {
      return i18n.t("UserHistory.orderDetails.value");
    },
    value: (val) => formatNumber(val),
  },
  provider: {
    get label() {
      return i18n.t("UserHistory.ordersList.provider");
    },
    value: (val) => val,
  },
  expiryDate: {
    get label() {
      return i18n.t("UserHistory.orderDetails.expiryDate");
    },
    value: (val) => dayjs(val).format("DD/MM/YYYY"),
  },
  code: {
    get label() {
      return i18n.t("UserHistory.orderDetails.code");
    },
    value: (val) => val,
  },
  cardCode: {
    get label() {
      return i18n.t("UserHistory.orderDetails.giftcardNumber");
    },
    value: (val) => {
      if (val) return val;
      return "-";
    },
  },
  cardPin: {
    get label() {
      return i18n.t("UserHistory.orderDetails.cardPin");
    },
    value: (val:string, extras:any) => {
      if (extras?.disappear) return "****";
      if (val) return val;
      return "-";
    },
  },
};
